import React from 'react';
import type { WaitingPageContent } from './waitingPageContent';
import { WAITING_PAGE_CLASS_NAMES, WAITING_PAGE_STYLE_SHEET } from './waitingPageStyles';

export interface WaitingPageProps extends WaitingPageContent {
    actionLabel?: string;
    busy?: boolean;
    onAction?: () => void;
}

const WaitingPage: React.FC<WaitingPageProps> = ({
    actionLabel,
    busy = true,
    message,
    onAction,
    title,
}) => (
    <main
        className={WAITING_PAGE_CLASS_NAMES.page}
        data-bustly-waiting-page
        aria-busy={busy}
    >
        <style>{WAITING_PAGE_STYLE_SHEET}</style>
        <section className={WAITING_PAGE_CLASS_NAMES.panel} aria-live="polite">
            <h1 className={WAITING_PAGE_CLASS_NAMES.title}>{title}</h1>
            <p className={WAITING_PAGE_CLASS_NAMES.message}>{message}</p>
            {actionLabel && onAction ? (
                <button
                    type="button"
                    className={WAITING_PAGE_CLASS_NAMES.button}
                    onClick={onAction}
                >
                    {actionLabel}
                </button>
            ) : null}
        </section>
    </main>
);

export * from './waitingPageContent';
export * from './waitingPageHtml';
export * from './waitingPageStyles';
export default WaitingPage;
